<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-p-4 tw-relative">
    <div mat-dialog-title class="matp-dialog-title">
      {{ "デバイス" }}{{ updating ? "編集" : "新規登録" }}
    </div>

    <mat-dialog-content class="tw-w-full !tw-pt-2">
      <div class="tw-flex tw-gap-x-4">
        <div class="tw-flex tw-flex-col tw-gap-y-4 tw-w-full">
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            [ngClass]="{ 'matp-form-field-readonly': updating }"
          >
            <mat-label>シリアル番号</mat-label>
            <input
              matInput
              formControlName="serialNo"
              name="serialNo"
              [required]="!updating"
              [readonly]="updating"
            />
            <mat-error *ngIf="formGroup.controls.serialNo.errors?.['required']">
              シリアル番号を入力してください。
            </mat-error>
            <mat-error
              *ngIf="formGroup.controls.serialNo.errors?.['maxlength']"
            >
              128文字以下で入力してください。
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>デバイス種類</mat-label>
            <mat-select formControlName="deviceTypeDisplayName">
              @for(deviceType of deviceTypeList; track deviceType.deviceTypeKey)
              {
              <mat-option [value]="deviceType.displayName">
                {{ deviceType.displayName }}
              </mat-option>
              }
            </mat-select>
            <mat-error
              *ngIf="formGroup.controls.deviceTypeDisplayName.errors?.['required']"
            >
              デバイス種類を選択してください
            </mat-error>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            floatLabel="always"
            [ngClass]="{ 'matp-form-field-readonly': updating }"
          >
            <mat-label>テナント名</mat-label>
            <mat-select formControlName="tenantId" [required]="!updating">
              @for(tenant of tenantList; track tenant.tenantId) {
              <mat-option [value]="tenant.tenantId">
                {{ tenant.tenantName }}
              </mat-option>
              }
            </mat-select>
            <mat-error *ngIf="formGroup.controls.tenantId.errors?.['required']">
              テナント名を選択してください
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>LPN(PKG ID)</mat-label>
            <input matInput formControlName="lpnId" name="lpnId" required />
            <mat-error *ngIf="formGroup.controls.lpnId.errors?.['required']">
              LPN(PKG ID)を入力してください。
            </mat-error>
            <mat-error *ngIf="formGroup.controls.lpnId.errors?.['maxlength']">
              128文字以下で入力してください。
            </mat-error>
          </mat-form-field>
          <div [formGroup]="contractFormGroup">
            <div class="tw-flex tw-space-x-4 tw-items-center">
              <mat-form-field
                appearance="fill"
                class="tw-flex-1"
                (click)="startDatePicker.open()"
              >
                <mat-label>契約開始日</mat-label>
                <input
                  matInput
                  [matDatepicker]="startDatePicker"
                  placeholder="YYYY/MM/DD"
                  formControlName="contractStartedAt"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="startDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
                <mat-error
                  *ngIf="contractFormGroup.controls.contractStartedAt.errors?.['required']"
                >
                  契約開始日を入力してください。
                </mat-error>
              </mat-form-field>
              <span class="tw-mx-2">~</span>
              <mat-form-field
                appearance="fill"
                class="tw-flex-1"
                (click)="endDatePicker.open()"
              >
                <mat-label>契約終了日</mat-label>
                <input
                  matInput
                  [matDatepicker]="endDatePicker"
                  placeholder="YYYY/MM/DD"
                  formControlName="contractExpiredAt"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="endDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
                <mat-error
                  *ngIf="contractFormGroup.controls.contractExpiredAt.errors?.['required']"
                >
                  契約終了日を入力してください。
                </mat-error>
              </mat-form-field>
            </div>
            <div class="tw-text-xs">
              @if (contractFormGroup.errors?.['dateRange']) {
              <mat-error
                >契約終了日は契約開始日より後の日付を入力してください。</mat-error
              >
              }
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
      <button
        id="cancel-btn"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="edit-btn"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="formGroup.invalid || contractFormGroup.errors?.['dateRange'] || 
        contractFormGroup.invalid"
      >
        <mat-icon>done</mat-icon>
        <span>{{ updating ? "変更" : "新規登録" }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
